import React from "react";
import { TutorialPlayerEmbeds } from "components/tutorial-player-embeds";

export const TutorialsPage: React.FC = () => {
    return <TutorialPlayerEmbeds />;
};
